import React from 'react';

const OnboardingStep0 = ({ onNext }) => {
    return (
        <div className="wizard-step">
            <div className="step-header">
                <h2>Welcome to RFQ Tracker!</h2>
                <p>Let's get your office set up. This will only take a few minutes.</p>
            </div>

            <div className="requirements-checklist">
                <h3 style={{ color: 'var(--text-primary)' }}>What you'll need:</h3>
                <ul style={{ fontSize: '16px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
                    <li>✓ Company information (name, address)</li>
                    <li>✓ Company logo (optional, PNG or JPEG)</li>
                    <li>✓ List of cities/regions you work in</li>
                    <li>✓ Contact list CSV file (optional)</li>
                    <li>✓ Team member email addresses</li>
                </ul>

                <div style={{ marginTop: '30px', padding: '20px', background: 'var(--bg-secondary)', borderRadius: '8px' }}>
                    <h4 style={{ color: 'var(--text-primary)' }}>Don't worry!</h4>
                    <p style={{ margin: '10px 0 0 0', color: 'var(--text-secondary)' }}>
                        You can skip optional items and add them later. You can also navigate back and forth between steps.
                    </p>
                </div>
            </div>

            <div className="step-footer">
                <div></div>
                <button onClick={onNext} className="btn-next">
                    Let's Get Started →
                </button>
            </div>
        </div>
    );
};

export default OnboardingStep0;

